import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import instantChatIcon1 from "../../images/v4/linkGeneration/icons/instantChatIcon1.svg";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import darkGreenCheck from "../../images/v4/industry/education/icons/darkGreenCheck.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import transformBackgroundImage from "../../images/v4/linkGeneration/images/transformBackgroundImage.png";

import partnerSectionBackground from "../../images/v4/linkGeneration/images/partnerSectionBackground.png";

import bestPracticeIcon1 from "../../images/v4/industry/food/icons/bestPracticeIcon1.svg";
import bestPracticeIcon2 from "../../images/v4/industry/food/icons/bestPracticeIcon2.svg";
import bestPracticeIcon3 from "../../images/v4/industry/food/icons/bestPracticeIcon3.svg";
import bestPracticeIcon4 from "../../images/v4/industry/food/icons/bestPracticeIcon4.svg";
import bestPracticeIcon5 from "../../images/v4/industry/food/icons/bestPracticeIcon5.svg";
import bestPracticeIcon6 from "../../images/v4/industry/food/icons/bestPracticeIcon6.svg";

import gridIcon1 from "../../images/v4/industry/food/icons/gridIcon1.svg";
import gridIcon2 from "../../images/v4/industry/food/icons/gridIcon2.svg";
import gridIcon3 from "../../images/v4/industry/food/icons/gridIcon3.svg";
import gridIcon4 from "../../images/v4/industry/food/icons/gridIcon4.svg";
import gridIcon5 from "../../images/v4/industry/food/icons/gridIcon5.svg";
import gridIcon6 from "../../images/v4/industry/food/icons/gridIcon6.svg";
import gridIcon7 from "../../images/v4/industry/food/icons/gridIcon7.svg";

import bestPracticeBg from "../../images/v4/industry/education/images/bestPracticeBg.png";
import industryHeroSectionBg from "../../images/v4/industry/education/images/industryHeroSectionBg.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/food/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/industry/food/images/compareItemImg5.png";

import featureSectionImg from "../../images/v4/industry/food/images/featureSectionImg.png";
import meaningImg from "../../images/v4/industry/food/images/meaningImg.png";
import benifitImg from "../../images/v4/industry/food/images/benifitImg.png";
import bodySectionBg from "../../images/v4/industry/education/images/bodySectionBg.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${industryHeroSectionBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "90px 0 220px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "0",
      paddingBottom: "300px",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: " linear-gradient(0deg, #401960 0%, #9E5AD5 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  pills: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    // marginTop: "25px",
  },
  pill: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "10px 16px",
    borderRadius: "30px",
    border: "1px solid #CEE9FF",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      padding: "10px 15px",
      "& img": {
        width: "20px",
      },
    },
  },
  experienceContainerHeader: {
    gap: "20px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "& h2": {
      width: "55%",
    },
    "& p": {
      width: "45%",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      "& h2": {
        width: "100%",
      },
      "& p": {
        width: "100%",
      },
    },
  },
  bodySection: {
    backgroundImage: `url(${bodySectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "top",
    paddingBottom: "300px",
    paddingTop: "260px",
    "& .container:first-child": {
      padding: "30px 0",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-460px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "500px",
      paddingBottom: "240px",
      "& .container:first-child": {
        padding: "30px 15px",
      },
    },
  },
  gridSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    rowGap: "24px",
    marginTop: "60px",
    "@media only screen and (max-width: 600px)": {
      marginTop: "40px",
    },
  },
  gridRow: {
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "24px",
    "&.row1": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "&.row2": {
      "& $gridCard": {
        width: "32%",
      },
    },
    "&.row3": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  gridCard: {
    display: "flex",
    flexDirection: "column",
    width: "48%",
    padding: "24px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    background: "#ffffff1a",
    borderRadius: "16px",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    gap: "16px",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100% !important",
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bestPracticeBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      paddingBottom: "170px",
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#fff",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "24px",
    width: "30%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(90deg, #011D32 0%, #00182B 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "75%",
    "@media only screen and (max-width: 600px)": {
      top: "91%",
    },
  },
  stripSection: {
    paddingTop: "280px",
    backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "180px",
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(180deg, #208EEC 0%, #002C51 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& $supportBox": {
        top: "-830px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  featureSection: {
    padding: "60px 0",
    background: "#F7F1FB",
  },
  featureSectionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "30px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  featureContainerLeft: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  featureContainerRight: {
    width: "50%",
    gap: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "& $cardPointer": {
      alignItems: "flex-start",
      "& img": {
        position: "relative",
        top: "5px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        position: "relative",
        top: "5px",
        width: "20px",
      },
    },
  },
  wpFaq: {
    // padding: "40px 0",
    "& $faqSection": {
      padding: 0,
    },
    background: "#F1FFF9",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  // testimonials: {
  //   paddingBottom: "40px",
  // },
}));

const FoodIndustry = () => {
  const classes = useStyles();
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question: "Does my restaurant need a CRM?",
      answer: (
        <>
          Yes, a CRM can help streamline operations, improve customer
          relationships, and boost sales for restaurants of all sizes.
        </>
      ),
    },
    {
      question: "How do I add customers to Pepper Cloud's restaurant CRM?",
      answer: (
        <>
          You can add customers manually through the dashboard, import them from
          existing databases, or automatically capture information from online
          orders and reservations.
        </>
      ),
    },
    {
      question: "What is CRM in F&B?",
      answer: (
        <>
          CRM in F&B (Food & Beverage) refers to software that helps manage
          customer relationships, track orders, and streamline marketing efforts
          for restaurants and food delivery businesses.
        </>
      ),
    },
    {
      question: "How can a CRM help me increase my restaurant sales?",
      answer: (
        <>
          A CRM can boost sales by enabling targeted marketing campaigns,
          personalised promotions, and improved customer retention through
          better service and engagement.
        </>
      ),
    },
    {
      question: "Is it worth investing in a CRM if I'm a small business?",
      answer: (
        <>
          Absolutely. A CRM like Pepper Cloud can help small businesses compete
          more effectively by improving customer service, streamlining
          operations, and enabling data-driven decision-making.
        </>
      ),
    },
    {
      question:
        "How does Pepper Cloud's WhatsApp integration benefit my restaurant?",
      answer: (
        <>
          WhatsApp integration allows for direct communication with customers,
          sending order updates, and running marketing campaigns through a
          widely used messaging platform.
        </>
      ),
    },
    {
      question: "How secure is customer data in Pepper Cloud CRM?",
      answer: (
        <>
          Pepper Cloud is an approved solution that employs robust security
          measures to protect customer data, ensuring compliance with data
          protection regulations.
        </>
      ),
    },
    {
      question: "Can Pepper Cloud help with managing online reviews?",
      answer: (
        <>
          Yes, Pepper Cloud's webform feature allows you to collect and manage
          customer feedback and reviews efficiently.
        </>
      ),
    },
    {
      question:
        "Is Pepper Cloud suitable for both dine-in restaurants and delivery-only businesses?",
      answer: (
        <>
          Absolutely. Pepper Cloud's features are versatile enough to cater to
          both traditional restaurants and delivery-focused operations.
        </>
      ),
    },
  ];
  const features1 = [
    {
      icon: gridIcon1,
      alt: "",
      heading: "Omnichannel marketing and support",
      desc: "Engage customers via social media, email, and WhatsApp for a seamless order-to-delivery experience.",
    },
    {
      icon: gridIcon2,
      alt: "",
      heading: "Personalisation at scale",
      desc: "Use personalized templates, automation, and customer data for tailored promotions, menu recommendations, and loyalty programmes.",
    },
  ];
  const features2 = [
    {
      icon: gridIcon3,
      alt: "",
      heading: "WhatsApp integration",
      desc: "Connect with customers on their preferred messaging platform for quick order updates, support, and promotions.",
    },
    {
      icon: gridIcon4,
      alt: "",
      heading: "Order tracking integration",
      desc: "Integrate with order tracking tools for real-time updates, reducing support calls and boosting satisfaction.",
    },
    {
      icon: gridIcon5,
      alt: "",
      heading: "Automated follow-ups",
      desc: "Automate order confirmations, delivery updates, and feedback requests for consistent communication without manual effort.",
    },
  ];
  const features3 = [
    {
      icon: gridIcon6,
      alt: "",
      heading: "AI-powered chatbot",
      desc: "Use chatbots to handle queries, take orders, and provide instant support, freeing staff for complex tasks.",
    },
    {
      icon: gridIcon7,
      alt: "",
      heading: "Telecalling support",
      desc: "Boost delivery and reservation with telecalling features for efficient order confirmation and customer support.",
    },
  ];
  const bestPractice = [
    {
      icon: bestPracticeIcon1,
      heading: "Keep it simple",
      desc: "Ask only for essential information to increase form completion rates.",
    },
    {
      icon: bestPracticeIcon2,
      heading: "Segment your customer base",
      desc: "Group customers based on preferences, order history, and behaviour for targeted marketing.",
    },
    {
      icon: bestPracticeIcon3,
      heading: "Personalise communications",
      desc: "Use customer data to tailor messages and offers for increased engagement.",
    },
    {
      icon: bestPracticeIcon4,
      heading: "Implement a loyalty programme",
      desc: "Reward repeat customers to encourage retention and increase lifetime value.",
    },
    {
      icon: bestPracticeIcon5,
      heading: "Train your staff",
      desc: "Ensure all team members are proficient in using the CRM to maximise its benefits.",
    },
    {
      icon: bestPracticeIcon6,
      heading: "Regularly update customer data",
      desc: "Maintain accurate and up-to-date information for effective communication and service.",
    },
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Toast CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM stands out as the top choice for restaurants and food delivery businesses in 2025. This all-in-one solution offers a comprehensive suite of features tailored specifically for the hospitality industry. With its powerful WhatsApp integration, AI-driven tools, and customisable dashboard, Pepper Cloud empowers restaurants to streamline operations, enhance customer engagement, and boost sales through personalised marketing campaigns.",
      img: compareItemImg1,
      alt: "Pepper Cloud - Best CRM for restaurants and food delivery",
      features: [
        {
          title: "Omnichannel marketing and support",
          desc: "Engage customers across multiple platforms, including WhatsApp, email, and social media, for seamless communication.",
        },
        {
          title: "WhatsApp integration",
          desc: "Leverage the popular messaging app for customer service, order updates, and marketing campaigns.",
        },
        {
          title: "AI-powered chatbot",
          desc: "Provide instant support and information to customers, improving response times and reducing staff workload.",
        },
        {
          title: "Order tracking tool integration",
          desc: "Keep customers informed about their delivery status in real-time, enhancing satisfaction and reducing support inquiries.",
        },
        {
          title: "Customisable dashboard",
          desc: "Tailor the CRM interface to display the most relevant information for your restaurant's needs.",
        },
        {
          title: "Mobile accessibility",
          desc: "Access critical business data and manage customer interactions on-the-go with iOS and Android apps.",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot offers a comprehensive CRM platform with robust sales pipeline management features, making it particularly suited for businesses already using its marketing tools. With a user-friendly interface and extensive educational resources, it's an attractive option for companies aiming to seamlessly align their sales and marketing efforts.",
      img: compareItemImg2,
      alt: "HubSpot",
      features: [
        {
          title: "Pipeline builder",
          desc: "Intuitive drag-and-drop pipeline builder allows users to customise their sales process with ease.",
        },
        {
          title: "Email tracking",
          desc: "Monitor email opens and clicks to gauge customer engagement.",
        },
        {
          title: "Meeting scheduler",
          desc: "Simplify appointment booking with an integrated scheduling tool.",
        },
        {
          title: "Reporting dashboard",
          desc: "Access detailed analytics to track performance and identify areas for improvement.",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce is a versatile CRM solution that can be adapted to various industries, including restaurants and food delivery. Its extensive customisation options and robust ecosystem of third-party integrations make it a powerful choice for businesses looking to scale their operations.",
      img: compareItemImg3,
      alt: "Salesforce",
      features: [
        {
          title: "Customer 360",
          desc: "Gain a complete view of customer interactions across all touchpoints.",
        },
        {
          title: "Einstein AI",
          desc: "Leverage artificial intelligence for predictive analytics and personalised recommendations.",
        },
        {
          title: "AppExchange",
          desc: "Access a wide range of industry-specific add-ons and integrations.",
        },
        {
          title: "Mobile app",
          desc: "Manage customer relationships on-the-go with a feature-rich mobile application.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM offers a cost-effective solution for small to medium-sized restaurants and food delivery businesses. Its user-friendly interface and comprehensive feature set make it an excellent choice for those new to CRM systems.",
      img: compareItemImg4,
      alt: "Zoho",
      features: [
        {
          title: "Zia AI assistant",
          desc: "Receive AI-powered insights and automation suggestions.",
        },
        {
          title: "Gamification",
          desc: "Motivate sales teams with built-in gamification features.",
        },
        {
          title: "Social media integration",
          desc: "Monitor and engage with customers across various social platforms.",
        },
        {
          title: "Customisable modules",
          desc: "Tailor the CRM to fit specific restaurant and food delivery needs.",
        },
      ],
    },
    {
      title: "Toast CRM",
      desc: "Toast is a restaurant-specific POS system that includes CRM functionality, making it a good option for businesses looking for an all-in-one solution. It offers features tailored to the unique needs of the food service industry.",
      img: compareItemImg5,
      alt: "Toast",
      features: [
        {
          title: "Guest profiles",
          desc: "Build detailed customer profiles based on order history and preferences.",
        },
        {
          title: "Loyalty programme",
          desc: "Create and manage customer loyalty programmes directly within the system.",
        },
        {
          title: "Online ordering integration",
          desc: "Seamlessly connect online orders with customer profiles.",
        },
        {
          title: "Menu management",
          desc: "Easily update menus and sync changes across all platforms.",
        },
      ],
    },
  ];
  const industryFeature = [
    {
      title: "Assess your specific needs",
      desc: "Identify key challenges and prioritise features that address them.",
    },
    {
      title: "Consider scalability",
      desc: "Choose a CRM that grows with your business, offering scalable features and capacity.",
    },
    {
      title: "Evaluate integration capabilities",
      desc: "Ensure the CRM integrates with your existing tools like POS and accounting software.",
    },
    {
      title: "Check for mobile accessibility",
      desc: "Choose a CRM with mobile apps for managing customer relationships on-the-go.",
    },
    {
      title: "Analyse reporting features",
      desc: "Look for CRM analytics and reporting tools to gain insights into customer behavior and business performance.",
    },
  ];
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <main>
      <SEO
        title={"Best CRM software for food delivery/Restaurant | Pepper Cloud"}
        pathname={
          "https://peppercloud.com//industry/best-crm-for-food-delivery-business"
        }
        keywords="best crm for restaurants and food delivery industry, food and beverage crm, restaurant crm tool, restaurant crm, best crm for restaurants, restaurant crm software, crm for food delivery"
        description={
          "Best CRM system for food delivery or restaurant businesses to streamline tasks, optimize employees' work, and improve communication between the business and its customers"
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Does my restaurant need a CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, a CRM can help streamline operations, improve customer relationships, and boost sales for restaurants of all sizes.",
                },
              },
              {
                "@type": "Question",
                name: "How do I add customers to Pepper Cloud's restaurant CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can add customers manually through the dashboard, import them from existing databases, or automatically capture information from online orders and reservations.",
                },
              },
              {
                "@type": "Question",
                name: "What is CRM in F&B?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CRM in F&B (Food & Beverage) refers to software that helps manage customer relationships, track orders, and streamline marketing efforts for restaurants and food delivery businesses.",
                },
              },
              {
                "@type": "Question",
                name: "How can a CRM help me increase my restaurant sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A CRM can boost sales by enabling targeted marketing campaigns, personalised promotions, and improved customer retention through better service and engagement.",
                },
              },
              {
                "@type": "Question",
                name: "Is it worth investing in a CRM if I'm a small business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. A CRM like Pepper Cloud can help small businesses compete more effectively by improving customer service, streamlining operations, and enabling data-driven decision-making.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud's WhatsApp integration benefit my restaurant?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "WhatsApp integration allows for direct communication with customers, sending order updates, and running marketing campaigns through a widely used messaging platform.",
                },
              },
              {
                "@type": "Question",
                name: "How secure is customer data in Pepper Cloud CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud is an approved solution that employs robust security measures to protect customer data, ensuring compliance with data protection regulations.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud help with managing online reviews?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud's webform feature allows you to collect and manage customer feedback and reviews efficiently.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud suitable for both dine-in restaurants and delivery-only businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. Pepper Cloud's features are versatile enough to cater to both traditional restaurants and delivery-focused operations.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-18"
              style={{ color: "#0291AE" }}
            >
              Food industry
            </motion.h1>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              The best CRM for restaurants and food delivery
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Pepper Cloud CRM is the game-changing solution that streamlines
              operations, boosts customer satisfaction, and drives growth for
              restaurants and food delivery businesses of all sizes.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Unify orders, service, and marketing
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Personalised promotions
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Streamline delivery with automation.
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link className="primaryButton font-20 font-wix-medium font-white">
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.bodySection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What is a restaurant CRM?
              </p>
              <p
                className="font-18 font-inter-regular"
                style={{ color: "#BEE7E7" }}
              >
                A restaurant CRM tool helps manage orders, delivery tracking,
                and customer engagement while improving efficiency. The best CRM
                for restaurants and food delivery strengthens loyalty and
                streamlines operations, making it essential for the food and
                beverage CRM needs of modern businesses.
              </p>
              <div className={classes.pills}>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    AI-powered
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    WhatsApp capabilities
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    Easy to use
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    24/7 Local support
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    source={whiteCheckCircle}
                    alt={"pointer"}
                    className={classes.pointerImg}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    No hidden charges
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={meaningImg}
                alt={"Benefits of WhatsApp link generator"}
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className={classes.experienceContainerHeader}>
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Why Pepper Cloud is the best CRM for restaurants and food delivery
              industry
            </motion.h2>
          </div>
          <div className={classes.gridSection}>
            <div className={clsx(classes.gridRow, "row1")}>
              {features1.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.heading} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row2")}>
              {features2.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.heading} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row3")}>
              {features3.map((feature) => (
                <div className={classes.gridCard}>
                  <img src={feature.icon} alt={feature.heading} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What are the benefits of using CRM in the food industry?
              </p>
              <div className={classes.pointers}>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Streamlined customer data management: Centralise customer
                    data, preferences, and order history for personalised
                    service and targeted marketing.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Enhanced customer experience: Use customer data for tailored
                    recommendations and a personalised dining experience.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Efficient order management: Integrate order tracking to
                    streamline processes, reduce errors, and boost efficiency.
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    source={whiteCheckCircle}
                    className={classes.pointerImg}
                    alt={"pointer"}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Automated marketing campaigns: Implement targeted
                    promotions, loyalty programs, and follow-ups to boost
                    retention and sales.
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benifitImg}
                alt={
                  "What are the benefits of using CRM in the restaurant and food industry?"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 best CRM for restaurants and food delivery industry in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.featureSection}>
        <div className="container">
          <div className={classes.featureSectionContainer}>
            <div className={classes.featureContainerLeft}>
              <LazyImage
                source={featureSectionImg}
                width={"100%"}
                alt={
                  "How to choose the best CRM for restaurants and food delivery industry"
                }
              />
            </div>
            <div className={classes.featureContainerRight}>
              <p className="font-wix-medium font-40 color-black1">
                How to choose the best CRM for restaurants and food delivery
                industry
              </p>
              <div className={classes.pointers}>
                {industryFeature.map((point) => (
                  <div className={classes.cardPointer}>
                    <LazyImage source={darkGreenCheck} alt={"pointer"} />
                    <p className="font-18 font-inter-regular color-black1">
                      {point.title}: {point.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Restaurants CRM software: Best practices
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-black1">
                  {practice.heading}
                </p>
                <p className="font-wix-medium font-16 font-black1">
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>
      </section>
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#F1FFF9"}
          heading={"FAQs - best CRM for restaurants and food delivery industry"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Revamp your restaurant operations - start today!
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default FoodIndustry;
